<template>
  <div :class="'md-layout-item md-small-size-100'">
    <md-card>
      <md-card-content>
        <div :class="'md-layout-item md-small-size-100'">
          <div :class="'md-layout'">
            <div :class="'md-layout-item'">
              <md-field :class="{ 'md-error': $v.questionnaire.name.$error }">
                <label>Name</label>
                <md-input v-model="questionnaire.name" @blur="$v.questionnaire.name.$touch()" 
                  type="text" maxlength="254">
                </md-input>
              </md-field>
            </div>
          </div>
          <div :class="'md-layout'">
            <div :class="'md-layout-item'">
              <label :class="'md-layout-item md-size-15 md-form-label'">
                RQR Type:
              </label>
              <md-radio v-for="(value, code) in listOfRqrType()" :key="code" v-model="questionnaire.rqr_type" :value="value.code">
                {{ value.label }}
              </md-radio>
            </div>
          </div>
          <div :class="'md-layout'" v-for="(section, i) in questions" :key="i">
            <div :class="'md-layout-item'">
              <h6>
                {{ i + 1 }}. {{ section.section_text }}
                {{
                  section.section_description
                    ? `- ${section.section_description}`
                    : ""
                }}
              </h6>
              <md-checkbox v-for="(question, i) in section.questions" :key="i" 
                v-model="questionnaire.questions" :value="question.id">
                {{ question.text }}
              </md-checkbox>
            </div>
          </div>
        </div>
      </md-card-content>
      <md-card-actions md-alignment="left">
        <md-button :class="'md-default'" @click="$router.push({ name: 'Questionnaires' })" >
          Back
        </md-button>
        <md-button :class="'md-danger'" @click.prevent="submit" :disabled="!isFormValid || isSubmitting">
          {{ !isSubmitting ? "Create" : "Creating Questionnaire..." }}
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import { rqrTypesMap } from "@/filters/rqrType"
import rqrTypeEnum from "@/enums/rqrType"

export default {
  created() {
    this.getQuestions();
  },

  data() {
    return {
      isFormValid: false,
      isSubmitting: false,
      questionnaire: {
        name: "",
        rqr_type: rqrTypeEnum.COMPLICE,
        questions: [],
      },
      questionsForCompliance: [],
      questionsForQuality: [],
      questionsForInFlight: [],
    };
  },

  computed: {
    questions() {
      if (this.questionnaire.rqr_type === rqrTypeEnum.COMPLICE)
        return this.questionsForCompliance;
      else if (this.questionnaire.rqr_type === rqrTypeEnum.QUALITY)
        return this.questionsForQuality;
      else if (this.questionnaire.rqr_type === rqrTypeEnum.IN_FLIGHT_REVIEW)
        return this.questionsForInFlight;      
    },
  },

  methods: {
    getQuestions() {
      this.$api
        .request(`questions-for-questionnaire?rqrType=1`)
        .then((response) => {
          this.questionsForCompliance = response.data;
        });

      this.$api
        .request(`questions-for-questionnaire?rqrType=2`)
        .then((response) => {
          this.questionsForQuality = response.data;
        });

      this.$api
        .request(`questions-for-questionnaire?rqrType=4`)
        .then((response) => {
          this.questionsForInFlight = response.data;
        });
    },

    listOfRqrType(){
      const rqrTypeArray = [];
      Object.entries(rqrTypesMap).forEach(([key, value]) =>
        rqrTypeArray.push({label: value, code: Number(key)})
      )
      return rqrTypeArray;      
    },

    submit() {
      if (this.isSubmitting)
        return;

      this.isSubmitting = true;
      this.$api.request
        .post("questionnaires", this.questionnaire)
        .then(() => {
          this.$toast.show("Questionnaire successfully created", "");
          this.$router.push({ name: "Questionnaires" });
        })
        .catch((error) => {
          const message = error.response.data.message
            ? error.response.data.message
            : "Ops, something went wrong! Please, try again.";

          this.$toast.warning(message);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },    
  },
  
  validations: {
    questionnaire: {
      name: {
        required,
        maxLength: maxLength(254),
      },
    },
  },
  
  watch: {
    "$v.questionnaire.$invalid": function () {
      this.isFormValid = !this.$v.questionnaire.$invalid;
    },
    "questionnaire.rqr_type": function () {
      this.questionnaire.questions = [];
    },
  },
};
</script>